<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="showCommissionsModal" :title="$t('Commissions')" size="lg" @show="onShow"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :ok-title="$t('Submit')"
                   :is-loading="loading" scrollable>
      <commission-tiers :model="model" show-minimum-commission-field/>

      <div class="row">
        <div class="col-md-4">
          <percentage-input-widget :model="model" attribute="insurance_rate"/>
        </div>
        <div class="col-md-4">
          <currency-input-widget :model="model" attribute="lot_handling_charge"/>
        </div>
        <div class="col-md-4">
          <percentage-input-widget :model="model" attribute="rebate_rate"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import CommissionForm from "../../../models/CommissionForm.model";
  import CurrencyInputWidget from "../../../../../core/widgets/CurrencyInputWidget";
  import PercentageInputWidget from "../../../../../core/widgets/PercentageInputWidget";
  import CommissionTiers from "@/core/components/commission-tiers/CommissionTiers";
  import Commission from "@/core/components/commission-tiers/Commission.model";

  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "CommissionsModal",
    components: {CommissionTiers, PercentageInputWidget, CurrencyInputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new CommissionForm()
      }
    },
    computed: {
      ...mapState({
        showCommissionsModal: state => state.termsData.showCommissionsModal,
        termDataCommissions: state => state.termsData.commissions,
        lot_handling_charge: state => state.termsData.lot_handling_charge,
        minimum_commission: state => state.termsData.minimum_commission,
        insurance_rate: state => state.termsData.insurance_rate,
        rebate_rate: state => state.termsData.rebate_rate
      }),
    },
    methods: {
      ...mapActions(['toggleCommissionsModal', 'saveTermsPartialData']),
      async onSubmit() {
        this.loading = true;
        let tmpData = this.model.toJSON()
        let requestData = tmpData.commissions.map(commission => commission.toJSON());
        let response = await this.saveTermsPartialData({
          commissions: requestData,
          minimum_commission: tmpData.minimum_commission,
          insurance_rate: tmpData.insurance_rate,
          lot_handling_charge: tmpData.lot_handling_charge,
          rebate_rate: tmpData.rebate_rate,
        });
        this.loading = false;

        if (response.success) {
          this.toggleCommissionsModal(false);
          this.$toast('success', this.$t('Commissions were successfully saved'));
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            for (let index in response.body.commissions) {
              this.model.commissions[index].setMultipleErrors(response.body.commissions[index]);
            }
          }
        }
      },
      onShow() {
        this.model = new CommissionForm({
          lot_handling_charge: this.lot_handling_charge,
          minimum_commission: this.minimum_commission,
          insurance_rate: this.insurance_rate,
          rebate_rate: this.rebate_rate,
          commissions: this.termDataCommissions.map(data => new Commission(data))
        })
      },
      onHidden() {
        this.model = new CommissionForm()
        this.toggleCommissionsModal(false);
      },
    },
    watch: {
      'model.rebate_rate'(newValue) {
        if (newValue && parseFloat(newValue) > 0) {
          this.model.minimum_commission = 0;
          if (this.model.commissions && this.model.commissions.length > 0) {
            this.model.commissions[0].percent = 0;
          }
        }
      },
      'model.minimum_commission'(newValue) {
        if (newValue && parseFloat(newValue) > 0) {
          this.model.rebate_rate = 0;
        }
      },
      'model.commissions': {
        handler(commissions) {
          if (commissions && commissions.length > 0) {
            for (let commission of commissions) {
              if (commission.percent && parseFloat(commission.percent) > 0) {
                this.model.rebate_rate = 0;
                break;
              }
            }
          }
        },
        deep: true
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>

